
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"42","height":"48","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M24 24c6.628 0 12-5.372 12-12S30.628 0 24 0 12 5.372 12 12s5.372 12 12 12zm8.4 3h-1.566A16.337 16.337 0 0124 28.5a16.37 16.37 0 01-6.834-1.5H15.6C8.644 27 3 32.644 3 39.6v3.9C3 45.984 5.016 48 7.5 48h33c2.484 0 4.5-2.016 4.5-4.5v-3.9C45 32.644 39.356 27 32.4 27z","id":"a"}})]),_c('g',{attrs:{"transform":"translate(-3)","fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('g',{attrs:{"mask":"url(#b)","fill":"#56BDD2"}},[_c('path',{attrs:{"d":"M0 0h48v48H0z"}})])])])
          )
        }
      }
    